import { Card } from 'reactstrap';
import { useState } from 'react';
import { AttendancesTable } from './AttendancesTable';
import {
  AttendanceTableLoader,
  AttendancesTableConsumer,
} from './AttendancesTableLoader';
import { TeacherFilter } from './TeacherFilter';
import { IdentificationTypesAsOptions } from '../types';
import {
  AttendancesViewLoader,
  AttendancesViewConsumer,
} from './AttendancesViewLoader';
import { AttendancesDateFilterAndTeacherInfo } from './AttendancesDateFilterAndTeacherInfo';
import DisplayInfo from '../../../../components/info/DisplayInfo';
import { useTexts } from '../hooks/useTexts';

type Props = {
  identificationTypes: IdentificationTypesAsOptions;
};

export function AttendancesView({ identificationTypes }: Props) {
  const [searched, setSearched] = useState(false);
  const texts = useTexts();

  return (
    <>
      <AttendancesViewLoader
        defaultIdentificationType={identificationTypes[0].value}
      >
        <>
          <Card style={{ backgroundColor: '#F0F0F0' }} className="mt-2 mx-3">
            <TeacherFilter
              identificationTypes={identificationTypes}
              setSearched={setSearched}
            />
          </Card>

          {!searched ? (
            <DisplayInfo
              insideCard
              title={texts.infoAndError.searchUserInfo.title}
              textBody={texts.infoAndError.searchUserInfo.body}
            />
          ) : (
            <AttendancesViewConsumer>
              {({ teacher }) => (
                <Card className="p-4 mt-2 mx-3">
                  <AttendanceTableLoader teacherId={teacher.id}>
                    <>
                      <AttendancesDateFilterAndTeacherInfo
                        teacherId={teacher.id}
                        teacherName={teacher.name}
                        teacherIdentification={teacher.identification}
                      />
                      <AttendancesTableConsumer>
                        {({ data }) => (
                          <AttendancesTable
                            data={data}
                            teacherId={teacher.id}
                          />
                        )}
                      </AttendancesTableConsumer>
                    </>
                  </AttendanceTableLoader>
                </Card>
              )}
            </AttendancesViewConsumer>
          )}
        </>
      </AttendancesViewLoader>
    </>
  );
}

//
